import axios from 'axios';

/*
*  This file contains all axios calls related rename campaign builder
*/

export const rename = async (funnelId, newFunnelName) => {
    const payload = {
        id: funnelId,
        name: newFunnelName,
    };

    await axios.post('/app/funnel/renameFunnel', payload);
};
